export function emitted(text, kind, nullable, atomic = true) {
    return { text, kind, nullable, atomic };
}
/** The runtime kind of a checked type: every number is one kind, strings and enum codes another. Null for the `null` literal's absent type and for a collection, which is never a value. */
export function kindOf(type) {
    switch (type?.base) {
        case 'Integer':
        case 'Decimal':
            return 'number';
        case 'Boolean':
            return 'boolean';
        case 'String':
        case 'Enum':
            return 'string';
        case 'Date':
        case 'DateTime':
            return 'date';
        default:
            return null;
    }
}
export function parenthesized(piece) {
    return piece.atomic ? piece.text : `(${piece.text})`;
}
